var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isError)?_c('v-img',{attrs:{"height":"200px","src":_vm.srcImage,"contain":""},on:{"error":function($event){_vm.isError = true}}}):_c('v-img',{attrs:{"src":"/img/media.jpg","height":"200px","cover":""}})}
var staticRenderFns = []

export { render, staticRenderFns }